import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "../components/Loader";
import ProtectedRoute from "../components/ProtectedRoute";
import PageNotFound from "../components/ErrorBoundary/PageNotFound";

// Lazy-loaded pages
const Dashboard = lazy(() => import("../pages/Dashboard"));
const AdminDashboard = lazy(() => import("../pages/Admin/adminDashboard"));
const Login = lazy(() => import("../auth/Login"));
const Register = lazy(() => import("../auth/Register"));

export default function RouterList() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* ========== Authentication Pages ========== */}
        <Route path="/admin" element={<Login />} />
        {/* <Route path="/register" element={<Register />} /> */}

        {/* ========== Protected Dashboard ========== */}
        <Route
          path="/"
          element={
            // <ProtectedRoute>
              <Dashboard />
            // </ProtectedRoute>
          }
        />
        {/* ========== Admin Dashboard ========== */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* ========== Catch All ========== */}
        {/* <Route path="*" element={<PageNotFound />} /> */}
      </Routes>
    </Suspense>
  );
}
